<template>
    <div class="echarts-map">
        <template v-if="currScreenType.isArea">
            <div class="map" id="map-town-level" v-auto-size></div>
            <div class="map map--up" id="map-area" v-auto-size></div>
        </template>
        <div v-else class="map" id="map-town-level" v-auto-size></div>
    </div>
</template>
<script>
import * as largeScreenAPI from '@/api/large-screen'
import * as fcScreenAPI from '@/api/fc-screen'
import { getRelativelySize } from '@/utils/size'

export default {
    data() {
        return {
            currScreenType: {},
            locTownLeveId: '',
            locTownLevelName: '',
            locAreaId: '',
            locAreaName: '',
            mapTownlevelInstance: null,
            mapAreaInstance: null,
            areaData: []
        }
    },
    destroyed() {
        if (this.mapTownlevelInstance) this.mapTownlevelInstance.dispose()
        if (this.mapAreaInstance) this.mapAreaInstance.dispose()
    },
    mounted() {
        this.currScreenType = JSON.parse(
            sessionStorage.getItem('currScreenType')
        )
        this.locTownLeveId = this.currScreenType.locId
        this.locTownLevelName = this.currScreenType.key

        this.getTownlevelEachrtInfo()
        this.$nextTick(() => {
            if (this.currScreenType.isArea) {
                this.locAreaId = `${this.currScreenType.locId}-map`
                this.locAreaName = `${this.currScreenType.key}pianqu`
                this.getAreaEachrtInfo()
            }

            this.init()
        })
    },
    methods: {
        init() {
            if (!this.mapTownlevelInstance) {
                this.mapTownlevelInstance = echarts.init(
                    document.getElementById('map-town-level')
                )
            }
            if (!this.mapAreaInstance && this.currScreenType.isArea) {
                this.mapAreaInstance = echarts.init(
                    document.getElementById('map-area')
                )
            }
        },
        // 获取第一级地图信息
        async getTownlevelEachrtInfo() {
            const { locTownLeveId, locTownLevelName } = this

            if (!this.currScreenType.isArea) {
                const response = await largeScreenAPI.mapAreaInfo({
                    locId: locTownLeveId
                })
                if (response.data.length) {
                    this.areaData = response.data.map((item) => {
                        return {
                            name: item.region,
                            jicha: item.jicha,
                            jifang: item.jifang,
                            jigeng: item.jigeng,
                            jishou: item.jishou,
                            jihong: item.jihong
                        }
                    })
                }
            }

            const responseJSON = await fcScreenAPI.getMapJSON(locTownLeveId)
            if (responseJSON.status === 200) {
                const mapJSON = responseJSON.data
                this.registerTownlevelMap(locTownLevelName, mapJSON)
                const options = this.getTownLevelOption(mapJSON.features)
                this.mapTownlevelInstance.setOption(options)
            }
        },
        // 获取第二级地图信息
        async getAreaEachrtInfo() {
            const { locAreaId, locAreaName } = this
            const params = {
                locId: locAreaId.split('-')[0]
            }
            const response = await largeScreenAPI.mapAreaInfo(params)

            if (response.data.length) {
                this.areaData = response.data.map((item) => {
                    return {
                        name: item.region,
                        jicha: item.jicha,
                        jifang: item.jifang,
                        jigeng: item.jigeng,
                        jishou: item.jishou,
                        jihong: item.jihong
                    }
                })
            }

            const responseJSON = await fcScreenAPI.getMapJSON(locAreaId)
            if (responseJSON.status === 200) {
                const mapJSON = responseJSON.data
                this.registerAreaMap(locAreaName, mapJSON)
                const options = this.getAreaOption(mapJSON.features)
                this.mapAreaInstance.setOption(options)
            }
        },
        registerTownlevelMap(name, json) {
            if (!echarts.getMap(name)) {
                echarts.registerMap(name, json)
            }
        },
        registerAreaMap(name, json) {
            if (!echarts.getMap(name)) {
                echarts.registerMap(name, json)
            }
        },
        getTownLevelOption(data) {
            const { locTownLevelName, areaData } = this

            let options = {
                geo: {
                    map: locTownLevelName,
                    aspectScale: 1,
                    zoom: 1.25,
                    label: {
                        show: true,
                        color: '#C1EFFC',
                        textShadowColor: 'rgba(0, 103, 174, 0.56)',
                        textShadowBlur: 10,
                        fontSize: getRelativelySize(14),
                        lineHeight: getRelativelySize(14),
                        formatter: function(params) {
                            let name = ''
                            if (params.name.length >= 6) {
                                name =
                                    params.name.slice(
                                        0,
                                        params.name.length / 2
                                    ) +
                                    '\n' +
                                    params.name.slice(
                                        params.name.length / 2,
                                        params.name.length
                                    )
                            } else {
                                name = params.name
                            }
                            return name
                        }
                    },
                    regions: data.map((item) => {
                        return {
                            name: item.properties.name,
                            itemStyle: {
                                normal: {
                                    areaColor: item.properties.color,
                                    borderColor: item.properties.borderColor,
                                    borderWidth: 2
                                }
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    color: '#fff'
                                },
                                itemStyle: {
                                    areaColor: '#EDD271'
                                }
                            }
                        }
                    })
                }
            }

            if (!this.currScreenType.isArea) {
                options.tooltip = {
                    padding: [
                        getRelativelySize(8),
                        getRelativelySize(18),
                        getRelativelySize(8),
                        getRelativelySize(18)
                    ],
                    backgroundColor: 'rgba(30,31,46,0.80)',
                    borderWidth: getRelativelySize(1),
                    borderColor: 'rgba(15,128,252,0.22)',
                    extraCssText: 'box-shadow: 0 0 8px 2px rgba(0,57,119,0.50)',
                    formatter: function(params) {
                        if (params.data !== undefined)
                            return `<div class="map__tip"><p class="map__tip--title">${params.data.name}</p><p>机耕：<span>${params.data.jigeng}</span>台</p><p>机插：<span>${params.data.jicha}</span>台</p><p>机防：<span>${params.data.jifang}</span>台</p><p>机收：<span>${params.data.jishou}</span>台</p><p>机烘：<span>${params.data.jihong}</span>台</p></div>`
                    }
                }
                options.series = [
                    {
                        type: 'map',
                        map: locTownLevelName,
                        geoIndex: 0,
                        data: areaData
                    }
                ]
            }

            return options
        },
        getAreaOption(data) {
            const { locAreaName, areaData } = this

            const options = {
                tooltip: {
                    padding: [
                        getRelativelySize(8),
                        getRelativelySize(18),
                        getRelativelySize(8),
                        getRelativelySize(18)
                    ],
                    backgroundColor: 'rgba(30,31,46,0.80)',
                    borderWidth: getRelativelySize(1),
                    borderColor: 'rgba(15,128,252,0.22)',
                    extraCssText: 'box-shadow: 0 0 8px 2px rgba(0,57,119,0.50)',
                    formatter: function(params) {
                        return `<div class="map__tip"><p class="map__tip--title">${params.data.name}</p><p>机耕：<span>${params.data.jigeng}</span>台</p><p>机插：<span>${params.data.jicha}</span>台</p><p>机防：<span>${params.data.jifang}</span>台</p><p>机收：<span>${params.data.jishou}</span>台</p></div>`
                    }
                },
                geo: {
                    map: locAreaName,
                    aspectScale: 1,
                    zoom: 1.25,
                    label: {
                        normal: {
                            show: true,
                            color: '#C1EFFC',
                            textShadowColor: 'rgba(0, 103, 174, 0.56)',
                            textShadowBlur: 10,
                            fontSize: getRelativelySize(16)
                        }
                    },
                    regions: data.map((item) => {
                        return {
                            name: item.properties.name,
                            itemStyle: {
                                normal: {
                                    areaColor: item.properties.color,
                                    borderColor: '#1D69BE',
                                    borderWidth: 2
                                }
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    color: '#fff'
                                },
                                itemStyle: {
                                    areaColor: '#EDD271'
                                }
                            }
                        }
                    })
                },
                series: [
                    {
                        type: 'map',
                        map: locAreaName,
                        geoIndex: 0,
                        data: areaData
                    }
                ]
            }

            return options
        }
    }
}
</script>
<style lang="scss" scoped>
.echarts-map {
    width: 100%;
    height: 100%;
    position: relative;
    .map {
        width: 100%;
        height: 100%;
        &--up {
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
        }
        ::v-deep {
            .map__tip {
                &--title {
                    font-size: 16px !important;
                    font-weight: 600;
                    margin-bottom: 5px !important;
                }
                p {
                    margin: 0;
                    font-size: 14px;
                    line-height: 24px;
                    span {
                        font-size: 18px;
                        color: #f9b236;
                        text-shadow: 0 2px 2px rgba(31, 24, 19, 0.6);
                        font-weight: 600;
                        margin-right: 5px;
                        position: relative;
                        top: 2px;
                    }
                }
            }
        }
    }
}
</style>
